<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="font-weight-bold mt-10 title-page" tabindex="0">Revisão de Crédito</div>
      </v-col>
    </v-row>

    <br />

    <div class="mt-4" v-if="dataset.loading">
      <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
    </div>

    <div v-if="!dataset.loading && user" v-html="dataset.contentUserLogged" tabindex="0"></div>

    <div v-if="user && !dataset.loading">

      <br>
      <v-divider></v-divider>
      <br>

      <v-alert v-if="awaitingAnswer.length" type="warning" text border="left" class="mt-2 mb-4" icon="mdi-message-reply-text-outline">
        <div class="font-weight-bold">{{ awaitingAnswer.length === 1 ? 'Há um pedido da Recuperanda aguardando sua resposta' : `Há ${awaitingAnswer.length} pedidos da Recuperanda aguardando sua resposta` }}</div>
        <div>A Recuperanda pediu a revisão do seu crédito. Responda até <strong>{{ $moment(awaitingAnswer[0].creditor_answer.deadline_at).format('DD/MM/YYYY') }}</strong>.</div>
        <v-btn small text color="warning darken-2" class="px-0 mt-1" @click="scrollToDebtorRequests">Ver pedido<v-icon right small>mdi-arrow-down</v-icon></v-btn>
      </v-alert>

      <template v-if="data && data.length && showLateWarning">
        <v-row>
          <v-col>
            <div class="red--text">
              <p>
                <strong>ATENÇÃO:</strong> Seu cadastro foi realizado após o prazo estabelecido para credenciamento na
                plataforma ({{ $modules.parameterDate('registration.credentialing_deadline') }} às {{ $modules.parameterTime('registration.credentialing_deadline') }}), sendo, portanto, considerada INTEMPESTIVA.
                Assim, a Administração Judicial informa que recebeu o pedido de Revisão de Crédito abaixo, mas a sua
                análise dependerá de deliberação do Juízo da Recuperação Judicial.
                Traremos novas informações sobre isso nesta página, tão logo exista definição no processo
              </p>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-if="showEndDateWarning">
        <v-row>
          <v-col>
            <div>
              <p>
                <strong>ATENÇÃO:</strong> Prezado credor, o prazo para envio das Revisões de Crédito encerrou-se em
                {{ $modules.parameterDate('review.timely_cutoff') }},
                conforme cronograma apresentado pela Administração Judicial, nos termos do EDITAL DE CONVOCAÇÃO PARA A
                FASE PRÉVIA E
                PRELIMINAR DE REVISÃO DE CRÉDITOS e de CONHECIMENTO DA RELAÇÃO DE CREDORES APRESENTADA PELA
                ADMINISTRAÇÃO JUDICIAL E
                PREVISTA NO ART. 7º, §2º, DA LEI 11.101/2005, elaborado conforme decisão judicial.
              </p>
            </div>
          </v-col>
        </v-row>
      </template>

      <v-row v-if="!this.loadingStatus && (data.length && !data.some(item => item.type !== 4))">
        <v-col>
          <span v-if="!dataset.isAssociationCreditor">
            Atualmente, você não está incluído na lista. Você apresentou o pedido de alteração da lista abaixo:
          </span>
          <span v-else>
            Atualmente, você está incluído na lista pelo valor
            <strong>{{ (dataset.userRequestedValue || 0) | currency }}</strong>.

            <template v-if="data.some(item => item.type !== 4)">
              Você apresentou o pedido de alteração da lista abaixo:
            </template>
          </span>
          <!-- <span v-else>
            Atualmente, você está incluído na lista pelo valor <strong>{{ (dataset.userRequestedValue || 0) | currency
            }}</strong>. Você apresentou o pedido de alteração da lista abaixo:
          </span> -->
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div v-for="(item, i) in data" :key="i">
            <!-- Fase 1: "contraproposta ao QGC". Os pedidos da Recuperanda da Fase 2 ficam na seção própria, abaixo. -->
            <template v-if="item.type === 4 && !isPhase2DebtorRequest(item)">
              <v-card outlined class="pa-4 mb-4" style="border-left: 5px solid #2196F3;">
                <v-row align="center">
                  <v-col>
                    <div class="headline mb-1">Você recebeu uma Contraproposta ao QGC!</div>

                    <v-chip v-if="item.creditor_decision" small
                      :color="item.creditor_decision === 1 ? 'success' : 'error'" class="mb-2">
                      {{ item.creditor_decision === 1 ? 'Aceita' : 'Rejeitada' }}
                    </v-chip>

                    <div v-for="(eventItem, eventIndex) in item.items" :key="'offer-' + eventIndex">
                      <strong>Valor proposto:</strong>
                      <span class="primary--text font-weight-bold">
                        {{ formatValue(eventItem.amount, eventItem.currency) }}
                      </span>
                      <!-- <span v-if="!eventItem.fgts_amount" class="primary--text font-weight-bold">
                          {{ formatValue(eventItem.amount, eventItem.currency) }}
                      </span> -->

                      <!-- <span v-else class="primary--text font-weight-bold">
                          R$ {{ eventItem.fgts_amount | currency }}
                      </span> -->

                      <!-- <div>
                        Documentos:
                        <div v-for="(doc, docIndex) in eventItem.documents" :key="'doc-' + docIndex">
                          <a :href="doc" target="_blank" class="primary--text">
                            Documento #{{ docIndex + 1 }}
                          </a>
                        </div>
                      </div> -->
                    </div>
                    <div class="caption grey--text mt-2">
                      Recebido em: {{ $moment(item.created_at).utc().format('DD/MM/YYYY') }}
                    </div>
                  </v-col>

                  <v-col cols="12" md="4" class="mt-4 mt-md-0" v-if="item.creditor_decision === null">
                    <v-alert dense outlined type="warning" class="ma-0">
                      O prazo para responder a esta contraproposta já foi encerrado.
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card>
              <br>
            </template>
          </div>
        </v-col>
      </v-row>

      <template v-if="
        dataset.isAssociationCreditor &&
        !hasPlanAdhesion &&
        user.can_open_creditor_revision &&
        user.objection_step_approved_amount_at === '0000-00-00 00:00:00' &&
        (
          data.length === 0 ||
          (
            data.every(item => item.type === 4) &&
            data.some(item => item.creditor_decision === null)
          )
        )
      ">
        <v-row class="justify-start">
          <v-col cols="12" class="mb-0">
            <span tabindex="0">Você já consta na lista de credores com o valor de <strong>{{ dataset.userRequestedValue
              |
              currency }}</strong>. Caso esteja de acordo, clique no botão abaixo. 
              <template v-if="$modules.isOpen('site.review.create.creditor')">Se não concordar com o valor,
              <a href="/#/revisao-credito/novo"><strong>clique aqui</strong></a></template>
            </span>

          </v-col>
          <v-col cols="12" class="mt-n5">
            <v-row class="mt-4">
              <v-col v-if="$modules.isOpen('site.review.agree_amount')" cols="auto">
                <v-btn small type="button" elevation="0" color="#4CAF50" class="w-100" dark
                  @click="approveAmount(dataset.userRequestedValue)">
                  Concordo com o valor da lista
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>

      <template
        v-if="dataset.isAssociationCreditor && hasPlanAdhesion && user.objection_step_approved_amount_at == '0000-00-00 00:00:00' && !data.length">
        <v-alert type="info">
          Você já aderiu ao plano de recuperação judicial, portanto não é possivel abrir uma revisão de crédito.
        </v-alert>
      </template>

      <template v-if="!user.can_open_creditor_revision && !data.length">
        <v-alert type="info">
          Seu cadastro foi criado após a data {{
            $moment(user.date_limit_open_creditor_revison).utc().format('DD-MM-YYYY') }} estipulada.
        </v-alert>
      </template>

      <ModuleClosedAlert module="site.review.create.creditor" />

      <v-row v-if="user.can_open_creditor_revision && !hasPlanAdhesion && !data.some(item => item.type !== 4) && $modules.isOpen('site.review.create.creditor')">
        <v-col>
          <p tabindex="0">
            <span>
              Caso queira adicionar uma revisão,
              <a href="javascript:void(0)" @click="handleRevisionClick"><strong>clique aqui</strong></a>
            </span>
          </p>
        </v-col>

      </v-row>

      <!-- <v-row v-if="user.requested_value"> -->
      <v-row v-if="user.objection_step_approved_amount_at">
        <v-col v-if="
          user.objection_step_approved_amount_at &&
          user.objection_step_approved_amount_at !== '0000-00-00 00:00:00'
        ">
          <p tabindex="0">
            <v-icon color="accent">mdi-currency-usd</v-icon> Você concordou com o valor de
            <!-- {{ user.creditorData.approved_amount | currency }} no dia -->
            <strong>{{ (dataset.userRequestedValue || 0) | currency }}</strong> no dia
            {{ user.objection_step_approved_amount_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" id="btnDiscord" type="button" elevation="0" color="#FFAB40"
                  class="ml-10" small dark @click="revogeApproveAmount()" tabindex="0"
                  aria-label="Botão para revogar aprovação de credito">
                  <v-icon left>mdi-restore</v-icon>
                  Revogar Aprovação
                </v-btn>
              </template>
              <span>Desfazer concordância do valor</span>
            </v-tooltip>
          </p>
        </v-col>
      </v-row>

      <v-row
        v-if="user.objection_step_approved_amount_at && user.objection_step_approved_amount_at !== '0000-00-00 00:00:00'">
        <v-col cols="12" md="8">
          <p>Informamos que o seu crédito encontra-se devidamente habilitado no processo de Recuperação Judicial
            do Grupo
            123 Milhas.</p>
          <p>Se você concorda com o valor informado no Edital (art.7º, §2º da Lei 11.101/2005), basta aguardar a
            próxima
            etapa: a convocação da Assembleia Geral de Credores, na qual será deliberada a aprovação do
            Plano de Recuperação Judicial apresentado pela Recuperanda.</p>
          <p>O Plano de Recuperação Judicial e o Relatório elaborado pela Administração Judicial estão disponíveis
            para
            consulta em nosso site. Para acessá-los, siga os passos:</p>
          <v-list dense nav>
            <v-list-item style="color: red;">
              <v-list-item-content>
                <v-list-item-title>● Acesse a aba <strong>Sobre o
                    Processo;</strong></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item style="color: red;">
              <v-list-item-content>
                <v-list-item-title>● Selecione <strong>Principais
                    Documentos;</strong></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item style="color: red;">
              <v-list-item-content>
                <v-list-item-title>● Clique em <strong>Plano
                    de
                    Recuperação Judicial.</strong></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <p>Permanecemos à disposição para eventuais esclarecimentos.</p>
        </v-col>
      </v-row>

      <template v-if="Array.isArray(data) && data.length > 0">

        <div v-if="hasLegacyProposal(data[0])">
          <br />
          <v-alert outlined
            :color="data[0].proposal_status === 1 ? 'green' : (data[0].proposal_status === 2 ? 'red' : '#FF6F00')"
            :style="{
              backgroundColor: 'transparent',
              borderColor: (data[0].proposal_status === 1 ? 'green' : (data[0].proposal_status === 2 ? 'red' : '#FF6F00')) + ' !important',
              borderWidth: '2px' + '!important',
            }" icon="mdi-alert-outline">

            <template v-if="data[0].proposal_status === 1">
              Você <strong>aceitou</strong> a contraproposta no valor de
              <strong>{{ formatValue(data[0].proposal_amount, 'BRL') }}</strong>
              no dia <strong>{{ $moment(data[0].proposal_creditor_at).format('DD/MM/YYYY') }}</strong>.
            </template>

            <template v-else-if="data[0].proposal_status === 2">
              Você <strong>rejeitou</strong> a contraproposta no valor de <strong>{{
                formatValue(data[0].proposal_amount, 'BRL') }}</strong>
              no dia <strong>{{ $moment(data[0].proposal_creditor_at).format('DD/MM/YYYY') }}</strong>.
            </template>

            <template v-else-if="isProposalExpired">
              Houve uma contraproposta no valor de
              <strong>{{ formatValue(data[0].proposal_amount, 'BRL') }}</strong>
              para você aceitar ou rejeitar. O prazo limite foi até o dia
              <strong>{{ $moment(data[0].proposal_deadline_at).format('DD/MM/YYYY') }}</strong>.
            </template>

            <template v-else-if="data[0].proposal_amount > 0"> Você recebeu uma contraproposta no valor de
              <strong>{{ formatValue(data[0].proposal_amount, 'BRL') }}</strong>
              e tem até o dia
              <strong>{{ $moment(data[0].proposal_deadline_at).format('DD/MM/YYYY') }}</strong>
              para aceitar ou rejeitar o valor.
            </template>

            <div class="mt-4 warning-copy" v-if="data[0].proposal_status === 0">
              O prazo para responder à contraproposta já foi encerrado
              <template v-if="data[0].proposal_deadline_at && data[0].proposal_deadline_at !== '0000-00-00 00:00:00'">
                em {{ $moment(data[0].proposal_deadline_at).format('DD/MM/YYYY') }}.
              </template>
            </div>
          </v-alert>
        </div>

        <template v-if="processes.length > 0">
          <v-row v-for="(process, processIndex) in processes" :key="process.id">
            <v-col cols="12" class="mb-n3">
              <strong>Processo #{{ processIndex + 1 }}</strong>
            </v-col>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header class="custom-panel-header">
                    <p><strong>Número:</strong> {{ process.number }}</p>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p><strong>Local:</strong> {{ process.local }}</p>
                    <p><strong>Tribunal:</strong> {{ process.court }}</p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </template>

        <br />
        <div v-if="data[0].status == 4 || requestedDocOutOfDate">
          <v-alert dark color="#FF6F00" icon="mdi-alert-outline">
            <template v-if="!requestedDocOutOfDate">
              Há uma solicitação de novos documentos! Atenção: O prazo limite para envio dos documentos é até o
              {{ requestedDocDeadline }}.
            </template>
            <template v-else>
              Houve uma solicitação de novos documentos! Atenção: O prazo limite para envio dos documentos finalizou
              {{ requestedDocDeadline }}.
            </template>
            <br>
            <v-btn v-if="!requestedDocOutOfDate" type="button" elevation="0" color="#FFAB40" outlined
              class="button-with-border" small dark @click="loadRequestedDocuments()">
              Documentos
            </v-btn>
          </v-alert>
        </div>

        <div v-if="data.some(item => item.type !== 4)" class="objection-section-title">
          <div class="text-h6 font-weight-bold">Seus pedidos de revisão</div>
          <div class="text-body-2 grey--text text--darken-1">Pedidos que você apresentou e a análise da Administração Judicial.</div>
        </div>
        <div v-for="(item, i) in data" :key="i">
          <v-card v-if="item.type !== 4" outlined class="rounded-lg mb-4">
            <div class="objection-panel__header">
              <div>
                <div class="text-overline grey--text text--darken-1 objection-panel__overline">Seu pedido</div>
                <div class="text-subtitle-1 font-weight-bold">Revisão #{{ i + 1 }}</div>
                <div class="text-caption grey--text text--darken-1">
                  Solicitada em {{ $moment(item.created_at).utc().format('DD/MM/YYYY') }}
                  <template v-if="item.analyzed_at && Number(item.status) !== 0"> · Analisada em {{ $moment(item.analyzed_at).utc().format('DD/MM/YYYY') }}</template>
                </div>
              </div>
              <v-spacer />
              <template v-if="item.status == 0">
                <v-btn id="btnEdit" small outlined color="primary" class="mr-1" aria-label="Editar este pedido de revisão de crédito" @click="editItem(item)">
                  <v-icon left small>mdi-pencil</v-icon>Editar
                </v-btn>
                <v-btn id="btnDelete" small text color="important" class="mr-2" aria-label="Remover este pedido de revisão de crédito" @click="openDeleteDialog(item)">
                  <v-icon left small>mdi-trash-can-outline</v-icon>Remover
                </v-btn>
              </template>
              <v-chip small label :color="reviewStatus(item).color" text-color="white">{{ reviewStatus(item).label }}</v-chip>
            </div>
            <v-divider />

            <div class="pa-4">
            <!-- Análise da Administração Judicial (ou o aviso de que ainda não foi analisado). -->
            <div class="objection-analysis mb-3" :class="{ 'objection-analysis--pending': !hasAnalysis(item) }">
              <div class="objection-field__label">Análise da Administração Judicial</div>
              <template v-if="hasAnalysis(item)">
                <div class="objection-field__text objection-analysis__summary">{{ analysisSummary(item) }}</div>
                <v-btn v-if="item.reason" small text color="primary" class="px-0 mt-1" @click="viewReason(item, i)">
                  <v-icon left small>mdi-text-long</v-icon>Ver análise completa
                </v-btn>
              </template>
              <div v-else class="objection-field__text grey--text text--darken-1">{{ reviewStatus(item).hint }}</div>
            </div>

            <v-row>
              <v-col>
                <template v-if="item.contradictory_status === 3 && objectionPhase(item) === 1">
                  <v-card outlined class="pa-4 mb-4" style="border-left: 5px solid #FF6F00;">
                    <v-row align="center">
                      <v-col>
                        <div class="headline mb-1">Contraproposta recebida!</div>
                        <div>
                          <strong>Valor proposto:</strong>
                          <span class="primary--text font-weight-bold">
                            {{ formatValue(item.contradictory_amount, item.contradictory_currency || 'BRL') }}
                          </span>
                        </div>
                        <div class="mt-2">
                          <strong>Motivo:</strong>
                          <span>{{ item.contradictory_reason }}</span>
                        </div>
                        <div class="mt-2" v-if="item.contradictory_creditor_decision === 1">
                          <v-chip color="success" dark>Aprovada pelo credor</v-chip>
                        </div>
                        <div class="mt-2" v-if="item.contradictory_creditor_decision === 2">
                          <v-chip color="error" dark>Rejeitada pelo credor</v-chip>
                        </div>
                        <div class="mt-2" v-if="!item.contradictory_creditor_decision">
                          <v-alert dense outlined type="warning" class="ma-0">
                            O prazo para responder a esta contraproposta já foi encerrado.
                          </v-alert>
                        </div>
                      </v-col>
                      <!-- <v-col cols="auto">
                        <template
                          v-if="!item.contradictory_creditor_decision || item.contradictory_creditor_decision === 0">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="success"
                                class="w-100 mr-2" :loading="loadingItem === item.id && loadingType === 1"
                                :readonly="loadingItem !== null" dark style="height: 30px;"
                                @click="approveRejectContradictory(item, 1)">
                                <v-icon left>mdi-check</v-icon> Aprovar
                              </v-btn>
                            </template>
      <span>Aprovar contraproposta</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="error" outlined
                                :loading="loadingItem === item.id && loadingType === 2" :readonly="loadingItem !== null"
                                style="height: 30px;" @click="approveRejectContradictory(item, 2)">
                                <v-icon left>mdi-close</v-icon> Rejeitar
                              </v-btn>
                            </template>
        <span>Rejeitar contraproposta</span>
      </v-tooltip>
      </template>
      <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="warning" dark
                                :loading="loadingItem === item.id && loadingType === 0" :readonly="loadingItem !== null"
                                style="height: 30px;" @click="approveRejectContradictory(item, 0)">
                                <v-icon left>mdi-history</v-icon> Revogar
                              </v-btn>
                            </template>
      <span>Revogar decisão da contraproposta</span>
      </v-tooltip>
      </template>
    </v-col> -->
                    </v-row>
                  </v-card>
                  <br>
                </template>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(eventItem, eventIndex) in item.items" :key="eventIndex">
                    <template v-if="eventItem.contradictory_status === 3 && objectionPhase(item) === 1">
                      <v-card outlined class="pa-4 mb-4" style="border-left: 5px solid #FF6F00;">
                        <v-row align="center">
                          <v-col>
                            <div class="headline mb-1">Contraproposta recebida!</div>
                            <div>
                              <strong>Valor proposto:</strong>
                              <span class="primary--text font-weight-bold">
                                {{ formatValue(eventItem.contradictory_amount, eventItem.contradictory_currency ||
                                  'BRL') }}
                              </span>
                            </div>
                            <div class="mt-2">
                              <strong>Motivo:</strong>
                              <span>{{ eventItem.contradictory_reason }}</span>
                            </div>
                            <div class="mt-2" v-if="eventItem.contradictory_creditor_decision === 1">
                              <v-chip color="success" dark>Aprovada</v-chip>
                            </div>
                            <div class="mt-2" v-if="eventItem.contradictory_creditor_decision === 2">
                              <v-chip color="error" dark>Rejeitada</v-chip>
                            </div>
                            <div class="mt-2" v-if="!eventItem.contradictory_creditor_decision">
                              <v-alert dense outlined type="warning" class="ma-0">
                                O prazo para responder a esta contraproposta já foi encerrado.
                              </v-alert>
                            </div>
                          </v-col>
                          <!-- <v-col cols="auto">
                            <template
                              v-if="!eventItem.contradictory_creditor_decision || eventItem.contradictory_creditor_decision === 0">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="success"
                                    class="w-100 mr-2" :loading="loadingItem === eventItem.id && loadingType === 1"
                                    :readonly="loadingItem !== null" dark style="height: 30px;"
                                    @click="approveRejectContradictory(eventItem, 1)">
                                    <v-icon left>mdi-check</v-icon> Aprovar
                                  </v-btn>
                                </template>
      <span>Aprovar contraproposta</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="error" outlined
                                    :loading="loadingItem === eventItem.id && loadingType === 2"
                                    :readonly="loadingItem !== null" style="height: 30px;"
                                    @click="approveRejectContradictory(eventItem, 2)">
                                    <v-icon left>mdi-close</v-icon> Rejeitar
                                  </v-btn>
                                </template>
        <span>Rejeitar contraproposta</span>
      </v-tooltip>
      </template>
      <template v-else>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="warning" dark
                                    :loading="loadingItem === eventItem.id && loadingType === 0"
                                    :readonly="loadingItem !== null" style="height: 30px;"
                                    @click="approveRejectContradictory(eventItem, 0)">
                                    <v-icon left>mdi-history</v-icon> Revogar
                                  </v-btn>
                                </template>
      <span>Revogar decisão da contraproposta</span>
      </v-tooltip>
      </template>
      </v-col> -->
                        </v-row>
                      </v-card>
                      <br>
                    </template>
                    <v-expansion-panel-header aria-label="Formulario com os dados do negócio">
                      <div>
                        <strong>Origem:</strong>
                        <span>
                          {{ truncateText(eventItem.origin || 'N/A', 30) }}
                        </span>
                        /
                        <strong>Valor:</strong>
                        <span v-if="eventItem.amount">
                          <!-- {{ eventItem.currency | enum(dataset.currencyTypes, "id", "currencyFormat") }} -->
                          <!-- {{ eventItem.amount | currency }} -->
                          {{ formatValue(eventItem.amount, eventItem.currency) }}
                        </span>
                        <span v-else>N/A</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <p tabindex="0">
                            <span class="section-info-title">Devedora</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              <!-- {{ item.client.name }} -->
                              {{ eventItem.company_name }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Origem</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ eventItem.origin }}</span>
                          </p>
                          <p v-if="eventItem.request_number" tabindex="0">
                            <span class="section-info-title">Nº de Identificação</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              eventItem.request_number
                            }}</span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Moeda</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ eventItem.currency | enum(dataset.currencyTypes, 'id', 'name') }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Valor</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ formatValue(eventItem.amount, eventItem.currency) }}
                            </span>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Observações</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              eventItem.observation
                            }}</span>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Análise da Administração Judicial</span>
                            <br />
                            <span class="section-info-value text-uppercase"
                              v-html="getTruncatedReason(eventItem.reason)"></span>
                            <v-btn v-if="eventItem.reason && stripHtml(eventItem.reason).length > 150" text small
                              color="primary" @click="toggleReason" class="ml-2">
                              {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                            </v-btn>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Documento(s)</span>
                            <br />
                            <span class="section-info-value">{{ eventItem.docs.length }} arquivo(s)</span>
                          </p>
                          <v-row>
                            <v-col v-for="(itemDoc, docIndex) in eventItem.docs" :key="docIndex">
                              <v-card>
                                <v-img @click="openDoc(itemDoc.doc.file_url)" class="rounded-xl"
                                  lazy-src="https://picsum.photos/id/11/10/6" :height="70" :width="70"
                                  :src="itemDoc.doc.file_url"></v-img>
                                <v-card-text class="pa-0 file-text">
                                  {{ itemDoc.doc.name }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>

                          <!-- <template>
                            <div v-if="dataset.data.release_status != 1">
                              <p class="mt-6">
                                <span class="section-info-title">Motivo</span>
                                <br />
                              </p>
                              <div v-html="completeReason ? item.reason : item.small_reason"></div>
                              <v-row>
                                <v-col>
                                  <v-btn color="primary" outlined @click.native="completeReason = !completeReason">
                                    {{
                                    completeReason ? 'Ocultar motivo completo' : 'Ver motivo completo'
                                    }}</v-btn>
                                </v-col>
                              </v-row>
                            </div>
  
                          </template> -->

                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <!-- Fase 2: contraditório da Recuperanda sobre este pedido (a contraproposta ficou só na Fase 1). -->
            <DebtorContradictoryCard v-if="objectionPhase(item) === 2" :event="item" />
            </div>
          </v-card>
        </div>
      </template>

      <!-- Fase 2: pedidos de revisão apresentados pela Recuperanda para este credor. -->
      <section v-if="phase2DebtorRequests.length" id="pedidos-recuperanda" class="mt-2">
        <div class="objection-section-title">
          <div class="text-h6 font-weight-bold">Pedidos da Recuperanda</div>
          <div class="text-body-2 grey--text text--darken-1">
            Pedidos de revisão do seu crédito apresentados pela Recuperanda. A análise é feita pela Administração Judicial.
          </div>
        </div>
        <DebtorRequestCard v-for="request in phase2DebtorRequests" :key="request.id" :event="request" />
      </section>

      <!-- <v-row no-gutters>
          <v-col>
            <br>
            <iframe width="600" height="500" src="https://www.youtube.com/embed/6okzXsdt0k0" frameborder="0"
              aria-hidden="true" arial-label="Video demonstrativo para criar uma habilitação ou divergência"
              allowfullscreen aria-label="Video de demonstração de como proceder" alt=""></iframe>
          </v-col>
        </v-row> -->

      <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
        <v-card>
          <v-img :src="selectedDoc" alt="" contain />
        </v-card>
      </v-dialog>

      <!-- Modal para exluir hab-div-->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="blue--text text--darken-2"
            style="border-bottom: 4px solid #007bff; padding-bottom: 8px;">
            Excluir revisão de crédito
          </v-card-title>
          <br>
          <v-card-text tabindex="0">
            Deseja <b>excluir</b> esta revisão de crédito?<br><br>
            <span class="font-weight-bold">OBS.:</span> Esta operação é irreversível! Caso necessário, outra revisão de
            crédito
            poderá ser criada.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" tabindex="0" text @click="dialog = false"
              aria-label="Botão para cancelar operação e não remover a revisão de crédito">Cancelar</v-btn>
            <v-btn color="red" tabindex="0" text @click="confirmDelete()"
              aria-label="Botão para confirmar a remoção da revisão de crédito">Excluir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Análise da Administração Judicial do pedido selecionado -->
      <ReviewAnalysisDialog v-model="dialogReason" :item="reasonItem" :label="`Revisão #${reasonIndex + 1}`" />

      <!-- Modal para enviar os documentos solicitados-->
      <v-dialog v-model="dialogUpdateRequestedDocs" max-width="800px">
        <v-card>
          <v-card-title class="card-title">
            Atualização de documentos
          </v-card-title>
          <br>

          <v-card-text>
            <p>Para mais detalhes sobre a documentação ausente, entre em contato por telefone através dos números
              indicados neste site.</p>
            <p>Documentos relacionados com as empresas 123 VIAGENS E TURISMO LTDA., ART VIAGENS E TURISMO LTDA.
              (HotMilhas), NOVUM INVESTIMENTOS PARTICIPAÇÕES S.A., LH -
              LANCE HOTEIS LTDA. e MM TURISMO & VIAGENS S.A. (MaxMilhas). A empresa HOTEL URBANO não faz parte deste
              processo e todos os documentos relacionados ao HOTEL
              URBANO serão desconsiderados.</p>
          </v-card-text>
          <v-divider></v-divider>

          <v-progress-linear v-if="documentUploadLoading" indeterminate color="blue">
          </v-progress-linear>

          <v-card-text>
            <v-container v-if="mainDocs.length > 0">
              <v-row>
                <v-col cols="12">
                  <h3>Documentos Principais</h3>
                  <v-list dense>
                    <v-list-item v-for="doc in mainDocs" :key="doc.id" class="align-start" style="margin-bottom: 20px;">
                      <v-row class="d-flex align-center justify-space-between">
                        <v-col cols="8" class="d-flex align-center">
                          <v-list-item-content class="doc-title">
                            <v-list-item-title>- {{ doc.name }}</v-list-item-title>
                          </v-list-item-content>
                        </v-col>

                        <div class="d-flex align-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-if="!doc.uploaded" :loading="isLoading(doc)" :disabled="isLoading(doc)"
                                @click="doc.selectedFile ? uploadDocument(doc, 1) : openFileDialog(doc)" outlined
                                color="primary" v-bind="attrs" v-on="on">
                                {{ doc.selectedFile ? 'Enviar' : 'Atualizar' }}
                              </v-btn>
                            </template>
                            <span v-if="!doc.selectedFile">Selecionar documento para ser enviado</span>
                            <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-show="!doc.uploaded && doc.selectedFile && doc.uploadStatus !== 'error'"
                                class="ml-2" color="red" @click="clearSelectedFile(doc)" v-bind="attrs" v-on="on">
                                mdi-close
                              </v-icon>
                            </template>
                            <span>Limpar e selecionar outro documento</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-show="doc.uploadStatus === 'error'" color="red" class="ml-3"
                                @click="retryUpload(doc)" v-bind="attrs" v-on="on">
                                mdi-close-circle
                              </v-icon>
                            </template>
                            <span>Erro no envio, clique aqui para tentar novamente</span>
                          </v-tooltip>
                        </div>

                        <div v-if="doc.uploaded || doc.uploadStatus === 'success'" class="d-flex align-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-show="!doc.selectedFile" color="green" class="ml-3" v-bind="attrs" v-on="on">
                                mdi-check-circle
                              </v-icon>
                            </template>
                            <span>Documento enviado</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn outlined small color="primary" class="ml-2" :loading="isLoading(doc)"
                                :disabled="isLoading(doc)"
                                @click="doc.selectedFile ? uploadDocument(doc, 1) : openFileDialog(doc)" v-bind="attrs"
                                v-on="on">
                                <template v-slot:default>
                                  <span v-if="!(activeDocumentId === doc.id && documentUploadLoading)">
                                    {{ doc.selectedFile ? 'Enviar' : 'Alterar' }}
                                  </span>
                                </template>
                                <template v-slot:loader>
                                  <v-progress-circular indeterminate color="primary" size="25" width="3" />
                                </template>
                              </v-btn>
                            </template>
                            <template v-slot:default>
                              <span v-if="doc.selectedFile">Enviar documento selecionado</span>
                              <span v-if="!doc.selectedFile">Substituir documento enviado anteriormente</span>
                            </template>
                          </v-tooltip>
                        </div>

                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>

            <v-divider v-if="mainDocs.length > 0"></v-divider>

            <v-container v-if="formattedRequestedDocs.length > 0">
              <v-row>
                <v-col cols="12">
                  <h3>Documentos Solicitados</h3>
                  <br>
                  <v-expansion-panels>
                    <v-expansion-panel v-for="(group, index) in formattedRequestedDocs"
                      :key="group.user_event_item_id + '-' + index">
                      <v-expansion-panel-header>
                        <div class="d-flex align-center">
                          <strong>Origem: </strong>
                          <span class="ml-2 mr-2">{{ group.origin }}</span>
                          /
                          <strong class="ml-2">Valor: </strong>
                          <span class="ml-2">{{ group.amount }}</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list dense>
                          <v-list-item v-for="(doc, docIndex) in group.docs" :key="doc.document_id + '-' + docIndex"
                            class="compact-item">
                            <v-list-item-content>
                              <v-list-item-title class="doc-title">
                                - {{ doc.name }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <div class="d-flex align-center">
                                <v-tooltip v-if="!doc.uploaded && doc.uploadStatus !== 'success'" bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="isLoading(doc)" :disabled="isLoading(doc)"
                                      @click="doc.selectedFile ? uploadDocument(doc, 2) : openFileDialog(doc)" outlined
                                      color="primary" v-bind="attrs" v-on="on">
                                      {{ doc.selectedFile ? 'Enviar' : 'Atualizar' }}
                                    </v-btn>
                                  </template>
                                  <span>
                                    {{ doc.selectedFile ?
                                      'Enviar documento selecionado' : 'Selecionar documento para ser enviado' }}
                                  </span>
                                </v-tooltip>

                                <v-tooltip v-if="!doc.uploaded && doc.selectedFile && doc.uploadStatus !== 'error'"
                                  bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="ml-2" color="red" @click="clearSelectedFile(doc)" v-bind="attrs"
                                      v-on="on">
                                      mdi-close
                                    </v-icon>
                                  </template>
                                  <span>Limpar e selecionar outro documento</span>
                                </v-tooltip>

                                <v-tooltip v-if="doc.uploadStatus === 'error'" bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="red" class="ml-3" @click="retryUpload(doc)" v-bind="attrs" v-on="on">
                                      mdi-close-circle
                                    </v-icon>
                                  </template>
                                  <span>Erro no envio! Clique aqui para tentar novamente</span>
                                </v-tooltip>

                                <div v-if="doc.uploaded || doc.uploadStatus === 'success'" class="d-flex align-center">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon color="green" class="ml-3" v-bind="attrs" v-on="on">
                                        mdi-check-circle
                                      </v-icon>
                                    </template>
                                    <span>Documento enviado</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn outlined small color="primary" class="ml-2" :loading="isLoading(doc)"
                                        :disabled="isLoading(doc)"
                                        @click="doc.selectedFile ? uploadDocument(doc, 2) : openFileDialog(doc)"
                                        v-bind="attrs" v-on="on">
                                        <span v-if="!isLoading(doc)">
                                          {{ doc.selectedFile ? 'Enviar' : 'Alterar' }}
                                        </span>
                                        <template v-slot:loader>
                                          <v-progress-circular indeterminate color="primary" size="25"
                                            width="3"></v-progress-circular>
                                        </template>
                                      </v-btn>
                                    </template>
                                    <span>{{ doc.selectedFile ? 'Enviar documento selecionado' :
                                      'Substituir documento enviado anteriormente' }}</span>
                                  </v-tooltip>
                                </div>
                              </div>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>


                  <input type="file" ref="fileInput" @change="handleFileChange" style="display: none"
                    :key="selectedDocument ? selectedDocument.document_id : 'new-file'" />
                </v-col>
              </v-row>
            </v-container>

          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="dialogUpdateRequestedDocs = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>

    <div class='mt-10' v-if='!user && !dataset.loading'>
      <h4>Por favor, realize o seu login para ter acesso à revisão de crédito.</h4>
    </div>

  </v-container>
</template>

<script>
import 'moment/locale/pt-br'
import { eventHub } from '@/main'
import currencyTypes from '@/common/data/currency-types.data'
import creditorDocTypes from '@/common/data/creditor-email-doc-types.data'
import businessDocTypes from '@/common/data/business-doc-types.data'
import axios from 'axios'

import moment from 'moment-timezone'
import DebtorRequestCard from '@/components/objection/DebtorRequestCard.vue'
import DebtorContradictoryCard from '@/components/objection/DebtorContradictoryCard.vue'
import ReviewAnalysisDialog from '@/components/objection/ReviewAnalysisDialog.vue'
import { objectionPhase, isPhase2DebtorRequest, hasLegacyProposal, reviewStatus, hasAnalysis, analysisSummary } from '@/common/util/objection-phase'

export default {
  components: { DebtorRequestCard, DebtorContradictoryCard, ReviewAnalysisDialog },
  props: {
    // event: {
    //     type: Object,
    //     required: true,
    //     default: () => ({ requestedDocs: [], items: [] })
    // }
  },
  data: () => ({
    user: null,
    data: [],
    loading: false,
    dialog: false,
    loadingItem: null,
    loadingType: null,
    dialogReason: false,
    reasonItem: null,
    reasonIndex: 0,
    hasPlanAdhesion: false,
    isReasonExpanded: false,
    selectedItem: null,
    creditorDocTypes: creditorDocTypes,
    businessDocTypes: businessDocTypes,
    requestedDocDeadline: null,
    requestedDocOutOfDate: false,
    dateLimitOpenCreditorRevision: null,
    dataset: {
      contentUserAnonymous: '',
      contentUserLogged: '',
      currencyTypes: currencyTypes,
      isAssociationCreditor: false,
      userRequestedValue: 0,
      loading: false,
      clients: [],
      data: {
        items: [],
        client: null,
        release_status: null,
      }
    },
    document: {
      files: []
    },
    selectedDocument: null,
    completeReason: false,
    selectedDoc: null,
    dialogViewDoc: false,
    dialogUpdateRequestedDocs: false,
    showModal: false,
    businessDocs: [],
    mainDocs: [],
    processedDocuments: [],
    processes: [],
    isTimely: false,
    showLateWarning: false,
    showEndDateWarning: false,
    loadingDocs: [],

    loadingStatus: false,
    documentUploadLoading: false,
    activeDocumentId: null,
    isLoaded: false,
  }),

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.loadData()
    this.loadUserInfo();
  },

  computed: {
    // Pedidos da Recuperanda com prazo aberto e ainda sem resposta (destaque no topo da página).
    awaitingAnswer() {
      return this.phase2DebtorRequests.filter(item => item.creditor_answer && item.creditor_answer.can_answer && !item.creditor_answer.answered);
    },
    // Pedidos da Recuperanda da Fase 2 (seção própria da página).
    phase2DebtorRequests() {
      return (Array.isArray(this.data) ? this.data : []).filter(item => isPhase2DebtorRequest(item));
    },

    isProposalExpired() {
      if (this.data.length && this.data[0].proposal_deadline_at) {
        const deadline = moment(this.data[0].proposal_deadline_at);
        const now = moment();
        return now.isAfter(deadline);
      }
      return false;
    },

    formattedRequestedDocs() {

      if (!this.data[0] || !this.data[0].requestedDocs || !this.data[0].items) {
        return [];
      }

      const groupedDocs = this.data[0].requestedDocs.reduce((acc, doc) => {

        const itemId = doc.user_event_item_id;

        if (!acc[itemId]) {

          const item = this.data[0].items.find(i => i.id === itemId) || {};

          acc[itemId] = {
            user_event_item_id: itemId,
            origin: item.origin || 'N/A',
            amount: this.formatAmount(item.amount),
            docs: []
          };
        }

        acc[itemId].docs.push({
          document_id: doc.document_id,
          user_event_item_id: doc.user_event_item_id,
          name: doc.document_id !== 50
            ? this.$options.filters.enum(doc.document_id, this.businessDocTypes, 'id', 'name')
            : doc.custom_name || this.$options.filters.enum(doc.document_id, this.businessDocTypes, 'id', 'name'),
          uploaded: doc.uploaded || 0,
          selectedFile: null,
          uploadStatus: null
        });

        return acc;

      }, {});

      return Object.values(groupedDocs);
    },
  },

  methods: {
    scrollToDebtorRequests() {
      const section = document.getElementById('pedidos-recuperanda');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    objectionPhase,
    isPhase2DebtorRequest,
    hasLegacyProposal,
    async approveRejectContradictory(item, value) {
      if (this.$moduleBlocked('site.review.contradictory')) return;
      // value: 1 = aprovar, 2 = rejeitar
      const action = value === 1 ? 'aprovar' : 'rejeitar';
      const confirmMsg = `Deseja realmente ${action} a contraproposta?`;
      const proceedAction = await this.$dialog.confirm({
        title: 'Confirmação',
        text: confirmMsg,
        color: value === 1 ? 'success' : 'error',
      });
      if (!proceedAction) return;
      this.loadingItem = item.id;
      this.loadingType = value;
      try {
        await axios.post(`/api/user-objection-events/save-contradictory-decision/${item.id}`, {
          decision: value,
          itemId: item.user_objection_event_id
        });

        this.$dialog.notify.info(`Contraproposta ${value === 1 ? 'aprovada' : value === 2 ? 'rejeitada' : 'atualizada'} com sucesso!`, {
          timeout: 4000,
        });
        this.loadData();
      } catch (error) {
        this.$dialog.notify.error(`Erro ao ${value === 1 ? 'aprovar' : value === 2 ? 'rejeitar' : 'atualizar'} contraproposta!`, {
          timeout: 4000,
        });
      } finally {
        this.loadingItem = null;
        this.loadingType = null;
      }
    },
    async loadData() {
      this.dataset.loading = true
      this.loadingStatus = true

      try {
        await this.loadText()
        // await this.loadClients();

        if (this.$root.user) {
          await this.verifyAssociation()
          //await this.loadUserInfo()
          await this.load()
          // await this.fetchReleaseStatus()
          await this.infoPlanAdherence()

        }
      } catch (error) {
        console.log('error ', error);
        this.$dialog.notify.error('Ocorreu um erro ao carregar as informações, tente novamente!', {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    clearSelectedFile(doc) {
      doc.selectedFile = null;
      doc.uploadStatus = null;
      this.selectedDocument = null;
      this.$forceUpdate();
    },

    retryUpload(doc) {
      if (doc.selectedFile) {
        this.uploadDocument(doc, 2);
      } else {
        this.openFileDialog(doc);
      }
    },

    formatAmount(value) {
      if (!value) return 'R$ 0,00';
      return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    isLoading(doc) {
      return this.loadingDocs.includes(doc.document_id);
    },

    openFileDialog(doc) {
      this.selectedDocument = doc;
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      if (this.selectedDocument && event.target.files.length > 0) {
        this.selectedDocument.selectedFile = event.target.files[0];
        this.$refs.fileInput.value = '';
        this.$forceUpdate();
      }
    },

    async uploadDocument(doc, type) {
      if (this.$moduleBlocked('site.review.documents')) return;

      this.loadingDocs.push(doc.document_id);

      try {
        const formData = new FormData();
        formData.append('file', doc.selectedFile);
        formData.append('document_id', doc.document_id);
        formData.append('user_event_item_id', doc.user_event_item_id);
        formData.append('type', type);

        const response = await axios.patch(`/api/user-objection-events/update-item-doc/${this.data[0].id}`, formData,
          {
            headers: { "Content-Type": "multipart/form-data", },

          }
        );

        this.$dialog.notify.info("Documento enviado com sucesso!", {
          position: "top-right",
          timeout: 5000,
        });

        doc.uploaded = 1;
        doc.uploadStatus = 'success';
        doc.selectedFile = null;
        this.selectedDocument = null;
      } catch (error) {
        doc.uploadStatus = 'error';
        console.error('Erro ao enviar documento:', error);
        this.$dialog.notify.error("Erro ao enviar documento!", {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.loadingDocs = this.loadingDocs.filter(id => id !== doc.document_id);
        this.$forceUpdate();
      }
    },

    async infoPlanAdherence() {

      this.dataset.loading = true;

      try {
        const response = await axios.get(`/api/user/plan-adherence-status-information`);

        const data = response.data && response.data.content && Array.isArray(response.data.content.data) ? response.data.content.data : [];

        if (data.length > 0) {
          const hasAdherence = data.some(item => Number(item.status) === 1);

          this.hasPlanAdhesion = hasAdherence ? true : false;
        }

      } catch (error) {
        this.hasPlanAdhesion = false;
      } finally {
        this.dataset.loading = false;
      }

    },

    // async uploadDocument(doc, type) {
    //   if (!doc.selectedFile) {
    //     this.$dialog.notify.error("Erro ao enviar o documento selecionado!", {
    //       position: "top-right",
    //       timeout: 5000,
    //     });
    //     return;
    //   }

    //   const formData = new FormData();
    //   formData.append("file", doc.selectedFile);
    //   formData.append("type", type);
    //   formData.append("ref", doc.id);

    //   if (doc.item_id) formData.append("item_id", doc.item_id);

    //   const targetList = type === 1 ? this.mainDocs : this.businessDocs;
    //   const targetDoc = this.findDocumentInList(targetList, doc.id, type);

    //   if (!targetDoc) {
    //     this.$dialog.notify.error("Documento não encontrado!", {
    //       position: "top-right",
    //       timeout: 5000,
    //     });
    //     return;
    //   }

    //   try {

    //     this.activeDocumentId = doc.id
    //     this.documentUploadLoading = true;

    //     const response = await axios.patch(
    //       `/api/user-objection-events/update-item-doc/${doc.event_id}`,
    //       formData,
    //       {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //         },

    //       }
    //     );

    //     if (response.status === 200) {
    //       const docIndex = type === 1
    //         ? this.mainDocs.findIndex((d) => d.id === doc.id)
    //         : this.businessDocs.findIndex((businessDoc) =>
    //             businessDoc.item_id === doc.item_id &&
    //             businessDoc.docs.some((d) => d.id === doc.id)
    //           );

    //       if (type === 1 && docIndex !== -1) {
    //         this.$set(this.mainDocs, docIndex, {
    //           ...this.mainDocs[docIndex],
    //           uploadStatus: "success",
    //           uploaded: true,
    //           selectedFile: null,
    //         });
    //       } else if (type !== 1 && docIndex !== -1) {
    //         const businessDoc = this.businessDocs[docIndex];
    //         const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);

    //         if (innerDocIndex !== -1) {
    //           this.$set(businessDoc.docs, innerDocIndex, {
    //             ...businessDoc.docs[innerDocIndex],
    //             uploadStatus: "success",
    //             uploaded: true,
    //             selectedFile: null,
    //           });
    //         }
    //       }
    //       this.businessDocs.forEach((businessDoc) => {
    //         businessDoc.docs.forEach((doc) => {
    //           if (doc.selectedFile !== null) {
    //             doc.selectedFile = null; 
    //           }
    //         });
    //       });

    //       this.$dialog.notify.success("Arquivo enviado com sucesso!", {
    //         position: "top-right",
    //         timeout: 5000,
    //       });
    //     } else {
    //       throw new Error("Erro não identificado!");
    //     }
    //   } catch (error) {

    //     const docIndex = type === 1
    //       ? this.mainDocs.findIndex((d) => d.id === doc.id)
    //       : this.businessDocs.findIndex((businessDoc) =>
    //         businessDoc.docs.some((d) => d.id === doc.id)
    //       );

    //     if (type === 1 && docIndex !== -1) {
    //       this.$set(this.mainDocs, docIndex, {
    //         ...this.mainDocs[docIndex],
    //         uploadStatus: "error",
    //         uploaded: false,
    //       });
    //     } else if (type !== 1 && docIndex !== -1) {
    //       const businessDoc = this.businessDocs[docIndex];
    //       const innerDocIndex = businessDoc.docs.findIndex((d) => d.id === doc.id);

    //       if (innerDocIndex !== -1) {
    //         this.$set(businessDoc.docs, innerDocIndex, {
    //           ...businessDoc.docs[innerDocIndex],
    //           uploadStatus: "error",
    //           uploaded: false,
    //         });
    //       }
    //     }

    //     this.$dialog.notify.error("Erro ao enviar o documento!", {
    //       position: "top-right",
    //       timeout: 5000,
    //     });
    //   }

    //   this.documentUploadLoading = false;
    //   this.activeDocumentId = null;
    // },

    // findDocumentInList(list, docId, type) {
    //   if (type === 1) {
    //     return list.find((doc) => doc.id === docId);
    //   } else {
    //     for (const businessDoc of list) {
    //       const foundDoc = businessDoc.docs.find((d) => d.id === docId);
    //       if (foundDoc) {
    //         return foundDoc;
    //       }
    //     }
    //   }
    //   return null;
    // },

    loadRequestedDocuments() {
      if (this.$moduleBlocked('site.review.documents')) return;

      this.dialogUpdateRequestedDocs = true;

    },

    // loadRequestedDocuments() {

    //   //if (this.isLoaded) {
    //     this.dialogUpdateRequestedDocs = true;
    //    // return;
    //  // }

    //   let requestedDocs = [];

    //   try {
    //     if (this.data[0] && this.data[0].requested_doc) {
    //       requestedDocs = JSON.parse(this.data[0].requested_doc);
    //     }
    //   } catch (error) {
    //     this.$dialog.notify.error("Erro ao buscar a lista de documentos!", { position: 'top-right', timeout: 5000 });
    //     return;
    //   }

    //   const currencyType = this.data && this.data.items && this.data.items[0] && this.data.items[0].currency
    //     ? this.data.items[0].currency
    //     : 1;
    //   const currencySymbol = this.dataset && this.dataset.currencyTypes
    //     ? this.dataset.currencyTypes.find(type => type.id === currencyType).symbol || 'R$'
    //     : 'R$';

    //   if (Array.isArray(requestedDocs) && requestedDocs.length > 0) {
    //     const mainDocs = [];
    //     const businessDocsGrouped = [];

    //     requestedDocs.forEach((docGroup) => {
    //       if (docGroup.user_event_id) {
    //         // Documentos principais
    //         const mainDocumentNames = docGroup.docs.map((doc) => {
    //           const foundDoc = this.creditorDocTypes.find((ref) => ref.id === doc.id);
    //           return foundDoc
    //             ? {
    //               ...foundDoc,
    //               uploaded: doc.uploaded || false,
    //               event_id: docGroup.user_event_id,
    //               selectedFile: null,
    //             }
    //             : null;
    //         }).filter(doc => doc !== null && doc.id !== 3);

    //         mainDocs.push(...mainDocumentNames);
    //       } else {
    //         // Documentos de negócios
    //         const existingBusiness = businessDocsGrouped.find(
    //           (business) => business.item_id === docGroup.user_event_item_id
    //         );

    //         if (existingBusiness) {
    //           docGroup.docs.forEach((doc) => {
    //             const businessDoc = this.businessDocTypes.find((ref) => ref.id === doc.id);
    //             if (businessDoc) {
    //               existingBusiness.docs.push({
    //                 ...businessDoc,
    //                 name: doc.id === 50 && doc.customName ? doc.customName : businessDoc.name,
    //                 uploaded: doc.uploaded || false,
    //                 event_id: this.data[0].id,
    //                 item_id: docGroup.user_event_item_id,
    //                 selectedFile: null,
    //               });
    //             }
    //           });

    //         } else {
    //           const newBusinessDocs = docGroup.docs.map((doc) => {
    //             const businessDoc = this.businessDocTypes.find((ref) => ref.id === doc.id);
    //             return businessDoc
    //               ? {
    //                 ...businessDoc,
    //                 name: doc.id === 50 && doc.customName ? doc.customName : businessDoc.name,
    //                 uploaded: doc.uploaded || false,
    //                 item_id: docGroup.user_event_item_id,
    //                 event_id: this.data[0].id,
    //                 uploadProgress: 0,
    //                 selectedFile: null,
    //               }
    //               : null;
    //           }).filter((doc) => doc !== null);

    //           const formattedAmount = new Intl.NumberFormat('pt-BR', {
    //             style: 'currency',
    //             currency: this.getCurrencyCode(currencyType),
    //           }).format(docGroup.amount || 0);

    //           businessDocsGrouped.push({
    //             item_id: docGroup.user_event_item_id,
    //             event_id: this.data[0].id,
    //             origin: docGroup.origin,
    //             amount: formattedAmount,
    //             docs: newBusinessDocs,
    //           });
    //         }
    //       }
    //     });

    //     this.isLoaded = true;
    //     this.mainDocs = mainDocs;
    //     this.businessDocs = businessDocsGrouped;
    //     this.dialogUpdateRequestedDocs = true;

    //   }
    // },

    getCurrencyCode(currencyType) {
      switch (currencyType) {
        case 1:
          return 'BRL';
        case 2:
          return 'USD';
        case 3:
          return 'EUR';
        default:
          return 'BRL';
      }
    },

    formatValue(value, currency) {
      if (value === null || value === undefined) {
        return 'N/A'
      }

      let options = {
        style: 'currency',
        currency: 'BRL'
      }

      switch (currency) {
        case 1:
          options.currency = 'BRL'
          break
        case 2:
          options.currency = 'USD'
          break
        case 3:
          options.currency = 'EUR'
          break
        default:
          options.currency = 'BRL'
      }

      return new Intl.NumberFormat('pt-BR', options).format(value)
    },

    truncateText(text, maxLength) {
      return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
    },

    openDoc(doc) {
      window.open(doc, '_blank')
    },

    verifyCondition() {
      return this.data.some(item => item.client && item.client.event_report_file);
    },

    async fetchReleaseStatus() {
      this.loadingStatus = true;

      try {
        const result = await axios.get(`/api/clients/1`);

        const data = result.data.content;

        this.dataset.data = {
          ...data,
          release_status: data.release_status,
        };

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.loadingStatus = false;
      }
    },

    async verifyAssociation() {
      const result = await axios.get('/api/user-creditors/association')

      const data = result.data.content

      // if (!data) return;

      if (!data || data.length === 0) return

      this.dataset.isAssociationCreditor = true
      this.dataset.userRequestedValue = data[0].amount
    },

    async loadText() {
      const result = await axios.get(`/api/dynamic-infos/keys`, {
        params: { keys: 'objection-request-description' }
      })

      if (!result.data.content) return

      let contentUserAnonymous = result.data.content.find(x => x.key === 'user-event-anonymous')
      let contentUserLogged = result.data.content.find(x => x.key === 'objection-request-description')

      this.dataset.contentUserAnonymous = contentUserAnonymous ? contentUserAnonymous.value : ''
      this.dataset.contentUserLogged = contentUserLogged ? contentUserLogged.value : ''
      // this.dataset.contentUserLogged = result.data.content[0].value
    },

    async loadUserInfo() {
      try {
        const result = await axios.get('/api/users/info')

        this.user = result.data.content

        this.isTimely =
          this.user.timely_date && this.user.timely_date !== '0000-00-00 00:00:00';

        if (this.user.created_at) {
          // Cadastro depois do prazo de credenciamento (Módulos e prazos > Parâmetros).
          this.showLateWarning = this.$moment(this.user.created_at).isAfter(this.$modules.parameter('registration.credentialing_deadline'));
        }

        if (this.user.created_at) {

          const isoString = this.user.created_at.replace(" ", "T") + "Z";
          const eventDate = new Date(isoString);
          const endLimit = new Date(Date.UTC(2026, 1, 6));

          // this.showEndDateWarning = eventDate.getTime() > endLimit.getTime();
          // } else {
          // this.showEndDateWarning = false;
        }

        this.showEndDateWarning = true

        const eventResponse = await axios.get(`/api/user-objection-events/request`);
        const events = eventResponse.data.content;

        // this.showLateWarning = events.some(event => {
        //   const eventDate = new Date(event.created_at);
        //   return eventDate >= new Date('2024-12-04T00:00:00');
        // });

      } catch (error) {
        console.error('Erro ao carregar informações do usuário:', error);
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000,
        });
      }
    },

    async load() {
      const result = await axios.get('/api/user-objection-events/request')

      this.data = result.data.content

      for (let event of this.data) {
        for (let item of event.items) {
          if (item.documents) {
            item.documents = JSON.parse(item.documents)
          }
        }
      }

      console.log('data ', this.data)

      this.processes = [];

      this.data.forEach(item => {
        if (Array.isArray(item.processes) && item.processes.length > 0) {
          this.processes = [...this.processes, ...item.processes]
        }
      })

      if (!this.data || !this.data.length) return;

      const reqData = this.data[0];

      if (reqData) {

        const requestedDocAt = reqData.requested_doc_at
          ? moment(reqData.requested_doc_at).utc()
          : null;

        if (requestedDocAt) {
          const deadlineDate = moment(requestedDocAt).add(72, 'hours').utc();
          const now = moment().utc();

          const dayOfWeek = deadlineDate.isoWeekday();
          if (dayOfWeek === 6) {
            deadlineDate.add(2, "days");
          } else if (dayOfWeek === 7) {
            deadlineDate.add(1, "day");
          }

          this.requestedDocOutOfDate = now.isAfter(deadlineDate);

          const hoursDifference = deadlineDate.diff(now, 'hours');

          const formattedDate = deadlineDate.tz('America/Sao_Paulo').format('DD/MM/YYYY [às] HH:mm');

          this.requestedDocDeadline = `dia ${formattedDate}`;
        }
      }
    },

    async approveAmount(amount) {
      if (this.$moduleBlocked('site.review.agree_amount')) return;

      const proceedAction = await this.$dialog.confirm({
        text: `Deseja concordar com o valor de ${this.formatAmount(amount)}?`,
        title: 'Concordar com valor',
        actions: {
          false: 'Cancelar',
          true: 'concordar'
        }
      });

      if (!proceedAction) return;

      this.dataset.loading = true;

      try {
        await axios.post(
          '/api/users/objection-amount',
        );

        this.$dialog.notify.success("Concordância do valor efetuada com sucesso!",
          { position: 'top-right', timeout: 5000 }
        );

        this.loadData();
        this.loadUserInfo();

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000,
        });
      } finally {
        this.dataset.loading = false;
      }
    },

    getColorByStatus(status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'accent'
        case 2:
          return 'important'
        case 3:
          return 'primary'
        case 4:
          return '#FF6F00'
        default:
          break
      }
    },

    getTextByStatus(status) {
      switch (status) {
        case 0:
          return 'Aguardando análise'
        case 1:
          return 'Aprovado'
        case 2:
          return 'Rejeitado'
        case 3:
          return 'Aprovado parcial'
        case 4:
          return 'Atualizar doc.'

        default:
          break
      }
    },

    editItem(item) {
      if (this.$moduleBlocked('site.review.edit')) return;
      this.$router.push(`revisao-credito/${item.id}`)
      window.scrollTo(0, 0)
    },

    openDeleteDialog(item) {
      if (this.$moduleBlocked('site.review.edit')) return;
      this.selectedItem = item;
      this.dialog = true;
    },

    async confirmDelete() {
      this.dialog = false;
      if (this.selectedItem) {
        await this.deleteItem(this.selectedItem);
      }
    },

    async deleteItem(item) {

      this.dataset.loading = true;

      try {
        const response = await axios.delete(`/api/user-objection-events/request/delete/${item.id}`)

        this.$dialog.notify.success("Revisão de crédito excluída com sucesso!", { position: 'top-right', timeout: 5000 });

        this.load()

      } catch (error) {
        let message = "Erro ao excluir a revisão de crédito!";

        if (
          error &&
          error.response &&
          error.response.status === 400 &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          message = error.response.data.content.error.message;
        }
        this.$dialog.notify.error(message, { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.loading = false;

        this.selectedItem = null;
      }

    },

    async revogeApproveAmount() {
      if (this.$moduleBlocked('site.review.agree_amount')) return;

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja revogar a concordância do valor efetuada anteriormente?',
        title: 'Revogar concordância',
        actions: {
          false: 'Cancelar',
          true: 'revogar'
        }
      });

      if (!proceedAction) return;

      this.dataset.loading = true;

      try {
        await axios.delete('/api/users/objection-amount')

        this.$dialog.notify.success("Concordância de crédito revogada com sucesso!", { position: 'top-right', timeout: 5000 });

        this.loadData()
        this.loadUserInfo()

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.loading = false;
      }

    },

    viewCreateEvent() {
      this.$router.push(`habilitacoes-divergencias/novo`)
    },

    viewReason(item, index = 0) {
      this.reasonItem = item;
      this.reasonIndex = index;
      this.dialogReason = true;
    },

    reviewStatus(item) {
      const status = reviewStatus(item);
      // No credor, o aviso de documentos solicitados fica logo acima (com o botão de envio).
      return Number(item.status) === 4 ? { ...status, hint: 'A Administração Judicial solicitou documentos. Envie-os pelo aviso acima.' } : status;
    },
    hasAnalysis,
    analysisSummary,

    stripHtml(html) {
      if (!html) return '';
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },

    getTruncatedReason(reason) {
      const rawText = this.stripHtml(reason);
      if (!this.isReasonExpanded && rawText.length > 150) {
        return rawText.substring(0, 150) + '...';
      }
      return rawText;
    },

    toggleReason() {
      this.isReasonExpanded = !this.isReasonExpanded;
    },

    handleRevisionClick() {
      if (this.$moduleBlocked('site.review.create.creditor')) return;

      if (this.user.objection_step_approved_amount_at !== '0000-00-00 00:00:00') {
        this.$dialog.notify.error('Não é possível adicionar uma revisão, pois já existe uma aprovação registrada!', {
          position: 'top-right',
          timeout: 3000,
        });
        return;
      }
      this.$router.push('/revisao-credito/novo');
    },

  }
}
</script>

<style lang="scss">


.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.section-info-title {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.section-info-value {
  font-family: 'Raleway';
  font-size: 14px;
  font-style: normal;
}

.custom-panel-header {
  min-height: 20px !important;
  line-height: 20px !important;
  padding-top: 5 !important;
  padding-bottom: 0 !important;
}

.card-title {
  border-bottom: 4px solid #2373c9 !important;
  padding-bottom: 8px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  // font-family: 'Raleway' !important;
  font-weight: 650 !important;
  font-size: 20px !important;
  font-style: bold !important;
  text-align: center !important;
}

.button-with-border {
  background-color: #ffffff;
  border: 2px solid #FF6F00;
  padding: 10px 20px;
  border-radius: 5px;
}

.button-with-border:hover {
  background-color: #f7994d;
  color: rgb(247, 243, 243) !important;
}

.warning-copy {
  color: #ff6f00;
  font-weight: 600;
}

.compact-item {
  margin: 0;
  padding: 0;
}

.compact-item p {
  margin: 4px 0;
  font-size: 14px;
}

.doc-title {
  white-space: normal;
  word-wrap: break-word;
  max-width: calc(100% - 120px);
  margin-right: 16px;
}

.compact-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>